import getStaticFile from "utils/getStaticFile";
const JAZZWIRE_LOGO = getStaticFile("img/JazzWire.png");

export const FEATURES = "features";
export const YOUTUBE = "youtube";
export const MASTERCLASS = "masterclass";
export const OPEN_STUDIO = "openstudio";
export const JAZZWIRE = "jazzwire";

export const FIRST_COLUMN_LABEL = "Features";
export const CHECK_COLUMN_LABELS = [
    { text: "YouTube Videos & Play Alongs", src: null },
    { text: "Masterclass", src: null },
    { text: "Open Studio", src: null },
    { text: "JazzWire", src: JAZZWIRE_LOGO },
];

export const COMPARISON_ROWS = [
    { text: "Personalized, 15-point Growth Plan upon initial sign-up and every 6 months afterward.", columns: [false, false, false, true]},
    { text: "Weekly tune-specific video lessons that are clearly defined with actionable goals.", columns: [false, false, false, true]},
    { text: "365/24/7 community engagement—camaraderie, support, friendship.", columns: [false, false, false, true]},
    { text: "Time-tested teaching philosophy and methodology designed for adult learners helping them grow and excel faster.", columns: [false, false, false, true]},
    { text: "Semi-monthly virtual happy hours to meet peers & instructors.", columns: [false, false, false, true]},
    { text: "Monthly live jam sessions (in select markets).", columns: [false, false, false, true]},
    { text: "Meet and Play with your peers at Summer/Winter Summits, Jazz Band Masterclass, etc.", columns: [false, false, false, true]},
    { text: "Guided listening videos—hear the masters the way your teachers do.", columns: [false, false, false, true]},
    { text: "Daily feedback from instructors on every post. Individual questions answered in timely fashion.", columns: [false, false, false, true]},
    { text: "Expert teaching faculty across all instruments.", columns: [false, false, false, true]},
];
